"use client";
import { Modal, ModalBody, ModalContent, ModalHeader, Spacer, UseDisclosureProps, cn } from "@heroui/react";
import { UseDisclosureReturn } from "@heroui/use-disclosure";
import { Button } from "@/components/custom";
import { useTranslations } from "next-intl";
import { FaWhatsapp } from "react-icons/fa6";
import Link from "next/link";
import { useEffect, useState } from "react";
import { useOTP } from "../contexts/otp";
import { usePasswordOTP } from "@/app/[locale]/(auth)/forgot-password/components/use-password-otp";
import { useModal } from "../contexts/modal";
import { useSWRConfig } from "swr";
import SuccessModal from "./success-modal";
import FailModal from "./fail-modal";
import { useRouter } from "@/i18n/routing";

export default function CustomerServiceModal({
  type,
  disclosure,
}: {
  type: "BANK" | "PASSWORD";
  disclosure: UseDisclosureReturn;
}) {
  const t = useTranslations();
  const [isClicked, SetClicked] = useState<boolean>(false);
  const { openModal } = useModal();
  const { openOTPSavedModal } = useOTP();
  const { openOTPSavedModal: openPasswordSavedModal } = usePasswordOTP();
  const { mutate } = useSWRConfig();
  const router = useRouter();
  useEffect(() => {
    if (disclosure.isOpen) {
      SetClicked(false);
    }
  }, [disclosure.isOpen]);

  return (
    <Modal
      {...disclosure}
      classNames={{
        header: "bg-[#0A2A27] text-center shadow-lg rounded-t-lg",
        body: "bg-[#021517]",
        footer: "bg-[#021517]",
        closeButton: cn("hover:bg-white/5 active:bg-white/10"),
      }}
    >
      <ModalContent>
        <ModalHeader className="min-h-10">{/**t("too-many-tries") */}</ModalHeader>
        <ModalBody>
          <div className="flex w-full flex-col items-center justify-center p-5">
            <span className="icon-icon12 pb-4 text-[3.5rem] text-[#FF3939]" />
            <div className="text-center">{t("exceeded-tries")}</div>
          </div>
          <div className="flex flex-col gap-3">
            <Button
              as={Link}
              href={process.env.NEXT_PUBLIC_CS_WHATSAPP}
              onPress={() => SetClicked(true)}
              target="_blank"
              className="mx-auto w-fit min-w-[260px] px-4"
            >
              <FaWhatsapp size={24} />
              {t("contact-cs")}
            </Button>
            {isClicked && (
              <Button
                onPress={() => {
                  disclosure.onClose();
                  type === "BANK" &&
                    openOTPSavedModal().then(async (res) => {
                      if (typeof res === "undefined") return;
                      if ("status_code" in res && res.status_code == 0) {
                        mutate("/api/bank-detail");
                        openModal(<SuccessModal description={t("successfully-updated-bank-account")} />, t("success"));
                      } else
                        openModal(<FailModal description={res?.message as string} />, t("failed-to-add-bank-account"));
                    });
                  type === "PASSWORD" &&
                    openPasswordSavedModal().then((e) => {
                      console.log(e);
                      router.push("/forgot-password/new");
                    });
                }}
                className="gradient-secondary mx-auto w-fit min-w-[260px] px-4 font-bold"
              >
                <span className="drop-shadow">{t("code-acquired")}</span>
              </Button>
            )}
          </div>
          <Spacer y={4} />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
